import type { Bonus } from '../types/content'

export const bonuses: Bonus[] = [
  {
    id: '1',
    title: 'Track & Field Strength & Power Development',
    headline:
      'Strength, power, plyometrics and event-specific physical preparation for Track & Field coaches',
    value: '27',
    points: [
      'Learn how strength work supports acceleration, speed, jumping, throwing, running economy and athlete robustness.',
      'Plyometric progressions and power development organized by event group and training age.',
      'How to place strength work inside the training week without compromising track quality.',
    ],
    benefit:
      'Stop treating strength training like a separate sport. Learn how to make it support Track & Field performance.',
  },
  {
    id: '2',
    title: '100 Track & Field Coaching Case Studies',
    headline: 'Real athlete problems, technical diagnosis and practical coaching solutions',
    value: '27',
    points: [
      'Each case follows the same path: Problem → What to Observe → Possible Causes → Coaching Decision → Training Direction → Progression.',
      'Cases across sprints, hurdles, relays, endurance, race walking, jumps and throws.',
      'Written so you can find the situation you are facing this week and act on it immediately.',
    ],
    benefit:
      'Learn how to solve real coaching problems instead of relying on generic advice.',
  },
  {
    id: '3',
    title: 'Advanced Track & Field Program Design',
    headline:
      'Build your own weekly structures, training blocks and event-specific programs',
    value: '27',
    points: [
      'Covers 3-day, 4-day and 5-day training weeks with worked examples.',
      'Preseason, competition season, tapering and event priorities.',
      'Volume and intensity distribution, plus programming for combined events.',
    ],
    benefit:
      'Move from following sessions to designing intelligent programs of your own.',
  },
  {
    id: '4',
    title: 'Injury Risk Reduction & Safe Return to Training',
    headline:
      'A coach-focused guide to safer progression, workload management and returning athletes after interruptions',
    value: '19',
    points: [
      'Sprint loading, jump contacts, throwing volume and endurance progression guidelines.',
      'Fatigue and warning signs, plus how to modify a session on the spot.',
      'Return-to-training progressions that stay inside the coach’s role.',
    ],
    benefit: 'Protect training quality without stepping outside the coach’s role.',
  },
  {
    id: '5',
    title: 'Mobility, Warm-Up & Movement Preparation',
    headline:
      'Event-specific preparation for sprinters, hurdlers, endurance athletes, jumpers and throwers',
    value: '19',
    points: [
      'Warm-up structures for training days, competition days and reduced space.',
      'Mobility and movement preparation matched to each event group.',
      'Adaptations for different athlete needs, ages and training environments.',
    ],
    benefit:
      'Stop using the same generic warm-up for every event and every athlete.',
  },
]

export const bonusValueRows = [
  { label: 'Strength & Power Development', value: '$27' },
  { label: '100 Coaching Case Studies', value: '$27' },
  { label: 'Advanced Program Design', value: '$27' },
  { label: 'Injury Risk Reduction & Safe Return', value: '$19' },
  { label: 'Mobility & Movement Preparation', value: '$19' },
]
